import { motion } from "motion/react";

interface RevealProps {
  children: React.ReactNode;
  className?: string;
  duration?: number;
  initialY?: string | number;
}

export function Reveal({
  children,
  className = "",
  duration = 0.5,
  initialY = "20%",
}: RevealProps) {
  return (
    <motion.div
      variants={{
        hidden: { opacity: 0, y: initialY },
        visible: { opacity: 1, y: "0%" },
      }}
      initial="hidden"
      transition={{ duration }}
      whileInView="visible"
      className={`relative overflow-hidden ${className}`}
    >
      {children}
    </motion.div>
  );
}
